import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-pagination" }

import { computed, watch, PropType } from 'vue'
import MiniPagination from './MiniPagination.vue'
import { PageData } from '@/types/common'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'CommonPagination',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  metaData: {
    type: Object as PropType<PageData>,
    required: true,
    default: () => ({}),
  },
  pageSizeOpt: {
    type: Array,
    default: () => [10, 20, 50, 100],
  },
},
  emits: ['loadPage', 'update:metaData'],
  setup(__props, { emit: emits }) {

const props = __props



const meta = computed<PageData>(() => props.metaData)
meta.value.limit ||= 10
meta.value.page ||= 1

const defaultPageSizeOpt = computed(() => {
  return props.pageSizeOpt
})



watch(meta, (v) => {
  emits('update:metaData', v)
})

const handleSizeChanged = (size: number) => {
  meta.value.page = 1
  emits('loadPage', {
    page: meta.value.page,
    limit: size,
  })
}

const handleCurrentChanged = (current: number) => {
  if (meta.value.page !== current) {
    meta.value.page = current
  }
  emits('loadPage', {
    page: current,
    limit: meta.value.limit,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(meta).count && _unref(meta).count > _unref(defaultPageSizeOpt)[0])
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          background: "",
          layout: "total, sizes, prev, pager, next",
          "page-sizes": _unref(defaultPageSizeOpt),
          "page-size": _unref(meta).limit,
          "onUpdate:page-size": _cache[0] || (_cache[0] = ($event: any) => ((_unref(meta).limit) = $event)),
          "current-page": _unref(meta).page,
          "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => ((_unref(meta).page) = $event)),
          total: _unref(meta).count,
          onSizeChange: handleSizeChanged,
          onCurrentChange: handleCurrentChanged
        }, null, 8, ["page-sizes", "page-size", "current-page", "total"]))
      : (_unref(meta).count === -1)
        ? (_openBlock(), _createBlock(MiniPagination, {
            key: 1,
            "current-page": _unref(meta).page,
            hasnext: (_unref(meta).hasnext as boolean),
            onCurrentChange: handleCurrentChanged
          }, null, 8, ["current-page", "hasnext"]))
        : _createCommentVNode("", true)
  ]))
}
}

})